<div class="text-center">
	<strong class="d-block">{{ rowData.averageBonus }}</strong>
</div>
